export const ATPLIVECHAT_SET_USER = 'ATPLIVECHAT_SET_USER';
export const ATPLIVECHAT_RESET = 'ATPLIVECHAT_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
